import { render, staticRenderFns } from "./OrderMessDetail.vue?vue&type=template&id=1ca89781&scoped=true"
import script from "./OrderMessDetail.vue?vue&type=script&lang=js"
export * from "./OrderMessDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderMessDetail.vue?vue&type=style&index=0&id=1ca89781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca89781",
  null
  
)

export default component.exports